import { createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import SecondaryNav from '@/components/SecondaryNav.vue'
import SecondaryTop from '@/components/SecondaryTop.vue'
import CateringOverview from '@/view/ai/CateringOverview.vue'

export default {
  __name: 'CateringLeads',
  setup(__props) {


return (_ctx, _cache) => {
  return (_openBlock(), _createBlock(SecondaryNav, null, {
    top: _withCtx(() => [
      _createVNode(SecondaryTop, { text: "Leads" })
    ]),
    main: _withCtx(() => [
      _createVNode(CateringOverview)
    ]),
    _: 1
  }))
}
}

}